import React, { useContext } from 'react';
import TextContent from '../ui/TextContent';
import Image from '@jetshop/ui/Image/Image';
import { styled } from 'linaria/react';
import SiteContentContext from '../SiteContent/SiteContentContext';
import { ButtonUI } from '../ui/ButtonUI';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { theme } from '../Theming/Theming';

const BrandContent = styled('div')`
  max-width: 900px;
  margin: 1% auto 3%;
  .image-wrapper {
    width: 100%;
  }
  .text-wrapper {
    padding: 2rem 0;
    > h3 {
      color: ${theme.colors.secondary};
    }
    > h1 {
      color: ${theme.colors.primary};
      margin-bottom: 1rem;
    }
    p {
      line-height: 1.2em;
    }
    button {
      margin-top: 1rem;
      width: 100%;
    }
  }
  ${theme.above.md} {
    display: flex;
    align-items: center;
    .image-wrapper {
      width: 50%;
    }
    .text-wrapper {
      width: 50%;
      padding: 2rem;
    }
  }
`;

export const DesignerContent = ({ category }) => {
  const { designerTitle, designerButton } = useContext(SiteContentContext);
  if (!category) return null;
  const hasImage = category?.images?.length > 0;

  return (
    <BrandContent>
      <div className="image-wrapper">
        {hasImage && (
          <Image
            critical={true}
            aspect={'1:1'}
            crop={true}
            src={category.images[4].url}
            sizes={[1, 1, 1, 1]}
            cover={true}
            quality={80}
          />
        )}
      </div>
      <div className="text-wrapper">
        <h3>{designerTitle}</h3>
        <h1>{category.name}</h1>
        <TextContent content={category.content} className="small" />
        <ButtonUI>
          <CategoryLink category={category}>{designerButton}</CategoryLink>
        </ButtonUI>
      </div>
    </BrandContent>
  );
};
